import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ObjectAssociationsManyToOneIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ObjectAssociationsManyToOne",
    children: [/*#__PURE__*/_jsx("path", {
      d: "m29.88 15.97-4.5 3.38c-.05.04-.11.06-.17.06a.29.29 0 0 1-.29-.29v-1.45c0-.15-.13-.28-.29-.29l-1.28-.04h-6.97v9.56c0 .22-.2.41-.42.41h-1.91l-11.64.03c-.16 0-.16-2.82 0-2.81h11.23v-7.15l-11.29.03c-.11 0-.31-.09-.31-.25 0 0-.07-1.72 0-2.28.02-.16.15-.29.32-.29h11.28V7.44l-11.32.03a.32.32 0 0 1-.31-.25V4.84c.04-.11.15-.19.27-.19h13.68c.22 0 .41.19.41.42v9.55h7.13l1.13-.03c.15 0 .28-.14.28-.29v-1.46c0-.06.01-.11.04-.16.09-.13.27-.17.4-.09l4.52 2.91s.05.04.08.06a.3.3 0 0 1-.07.41"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.3 16.25h.37v.07h-.37zM16.29 13.5h.53v.03h-.53z"
    })]
  }));
};